import { Media, Title } from '../Object';
import { Scroll } from '../Animation';

const Pagehead = (props) => {
  let src = `head/${props.slug}`;
  let alt = props.slug;

  return(
    <>
      <section className="p-head__wrap">
        <Media class="p-head__img--back" src={src} alt={alt}></Media>
        <Scroll>
          <div className="p-head__wrap--title">
            <Title slug={props.slug} type="center" jpClass="c-text--center c-text--white" enClass="c-text--center c-text--white"></Title>
          </div>
        </Scroll>
      </section>
    </>
  )
}

export default Pagehead;
